export default __webpack_public_path__ + "static/media/centro_odontologico_salta.d7abf96a.jpg";